var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolygonTool(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2751_121565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 6.66665H18.3335V4.16665H15.8335V5.00498L4.16683 2.05081V0.833313H1.66683V3.33331H2.50016V8.33331H0.833496V15H2.50016V16.6666H1.66683V19.1666H4.16683V18.3333H15.8335V19.1666H18.3335V16.6666H17.5002V15H19.1668V8.33331H17.5002V6.66665ZM16.6668 4.99998H17.5002V5.83331H16.6668V4.99998ZM2.50016 1.66665H3.3335V2.49998H2.50016V1.66665ZM3.3335 3.33331H4.16683V2.91498L15.8335 5.86915V6.66665H16.6668V8.33331H3.3335V3.33331ZM3.3335 18.3333H2.50016V17.5H3.3335V18.3333ZM17.5002 18.3333H16.6668V17.5H17.5002V18.3333ZM16.6668 16.6666H15.8335V17.5H4.16683V16.6666H3.3335V15H16.6668V16.6666ZM18.3335 9.16665V14.1666H17.5002V11.6666H16.6668V14.1666H15.8335V12.5H15.0002V14.1666H14.1668V9.99998H13.3335V14.1666H12.5002V12.5H11.6668V14.1666H10.8335V11.6666H10.0002V14.1666H9.16683V12.5H8.3335V14.1666H7.50016V9.99998H6.66683V14.1666H5.8335V12.5H5.00016V14.1666H4.16683V11.6666H3.3335V14.1666H1.66683V9.16665H18.3335Z",
    fill: "#717784"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2751_121565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonTool);
export default __webpack_public_path__ + "static/media/polygonTool.cf2f912bd8ab194bdfc31f4cf1922112.svg";
export { ForwardRef as ReactComponent };